// extracted by mini-css-extract-plugin
export var lock = "h_M";
export var qr = "h_N";